import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const fmtMoney = (v, dash = '—') =>
  v === null || v === undefined ? dash : `$${Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtPct = (v, dash = '—') =>
  v === null || v === undefined ? dash : `${Number(v).toFixed(1)}%`;

export const fmtNum = (v, dash = '—') =>
  v === null || v === undefined ? dash : Number(v).toLocaleString('en-US');

export const fmtRoas = (v, dash = '—') =>
  v === null || v === undefined ? dash : `${Number(v).toFixed(2)}x`;

export const minsToHM = (mins) => {
  if (!mins) return '0m';
  const h = Math.floor(mins / 60);
  const m = Math.round(mins % 60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const fileUrl = (path) => (path?.startsWith('/api') ? `${BACKEND_URL}${path}` : path);

// Streaming chat helper (SSE over fetch)
export async function streamChat(message, onDelta) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/ai/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ message }),
  });
  if (!res.ok || !res.body) throw new Error(`Chat failed (${res.status})`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop();
    for (const line of lines) {
      if (!line.startsWith('data: ')) continue;
      const payload = line.slice(6);
      if (payload === '[DONE]') return;
      try {
        const obj = JSON.parse(payload);
        if (obj.t) onDelta(obj.t);
      } catch (e) {
        // Incomplete SSE chunk; safe to skip — surfaced for debugging only
        console.debug('Skipping partial SSE line', e);
      }
    }
  }
}
